export enum HotspotType
{
    Unknown = "Unknown",
    Home = "Home", // "hotspot0"
    Initial = "Initial", // "hotspot1"
    Dedicated = "Dedicated", // "TX..."
    Concealed = "Concealed", // "Orange Free Wifi 5G", "Sala wykladowa C14-F", "VP3C4F44Y-MP9"  
    Custom = "Custom"
}
